export default {
  cancel: 'Cancel',
  save: 'Save',
  invite: 'Invite',
  lock: 'Lock',
};
